import React, { useState } from 'react';
import { HiOutlineSquares2X2, HiOutlineQrCode, HiOutlineCurrencyDollar } from 'react-icons/hi2';
import AffiliateCodeManager from './AffiliateCodeManager';
import EarningsReport from './EarningsReport';
import './Dashboard.css';

const DashboardLayout = () => {
  const [activeTab, setActiveTab] = useState(0);

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <AffiliateCodeManager />;
      case 1:
        return <EarningsReport />;
      default:
        return <AffiliateCodeManager />;
    }
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <div className="dashboard-card">
          {/* Dashboard Header */}
          <div className="dashboard-header">
            <HiOutlineSquares2X2 />
            <h1>Affiliate Dashboard</h1>
          </div>

          {/* Dashboard Navigation */}
          <div className="dashboard-tabs">
            <button 
              className={`dashboard-tab ${activeTab === 0 ? 'active' : ''}`} 
              onClick={() => setActiveTab(0)}
            >
              <HiOutlineQrCode />
              <span>Affiliate Codes</span>
            </button>
            <button 
              className={`dashboard-tab ${activeTab === 1 ? 'active' : ''}`} 
              onClick={() => setActiveTab(1)}
            >
              <HiOutlineCurrencyDollar />
              <span>Earnings</span>
            </button>
          </div>

          {/* Dashboard Content */}
          <div className="dashboard-content">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
